export class TrailsActions {
  static readonly GET_ALL = '[TRAILS] GET_ALL';
  static readonly GET_ALL_SUCCESS = '[TRAILS] GET_ALL_SUCCESS';
  static readonly GET_ALL_FAILURE = '[TRAILS] GET_ALL_FAILURE';
  static readonly SET_GEO_LOCATION = '[TRAILS] SET_GEO_LOCATION';
  static readonly SET_GEO_ZOOM = '[TRAILS] SET_GEO_ZOOM';
}
